import difference from 'lodash/difference';
import findIndex from 'lodash/findIndex';
import cloneDeep from 'lodash/cloneDeep';
import pickBy from 'lodash/pickBy';

/**
 * Laroute globals
 * TODO: implement as raw JS
 */
window.difference = difference;
window.findIndex = findIndex;
window.pickBy = pickBy;
window.cloneDeep = cloneDeep;
